import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from '@noor/lib';
import { getApiErrorMessage } from '@noor/api';
import {
  foodOrderApi,
  foodOrderKeys,
  type FoodOrder,
  type CancelFoodOrder,
  type CreateTestFoodOrder,
} from '@/entities/food-order';
export function useCancelFoodOrder(id: string) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (payload: CancelFoodOrder) => foodOrderApi.cancel(id, payload),
    onMutate: async ({ reason }) => {
      await client.cancelQueries({ queryKey: foodOrderKeys.all });
      const previous = client.getQueryData<FoodOrder>(foodOrderKeys.detail(id));
      if (previous)
        client.setQueryData<FoodOrder>(foodOrderKeys.detail(id), {
          ...previous,
          merchant_order_status: 'MERCHANT_ORDER_STATUS_CANCELLED',
          cancelled_by: 'admin',
          order: {
            ...previous.order,
            status: 'ORDER_STATUS_CANCELLED',
            cancel_reason: reason,
          },
        });
      return { previous };
    },
    onError: (error, _payload, context) => {
      if (context?.previous)
        client.setQueryData(foodOrderKeys.detail(id), context.previous);
      toast.error(getApiErrorMessage(error, 'Не удалось отменить заказ'));
    },
    onSuccess: () => {
      toast.success('Заказ отменён');
    },
    onSettled: async () => {
      await client.invalidateQueries({ queryKey: foodOrderKeys.all });
    },
  });
}
export function useCreateTestFoodOrder() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (payload: CreateTestFoodOrder) => foodOrderApi.createTest(payload),
    onSuccess: async () => {
      toast.success('Запрос создания тестового заказа отправлен');
      await client.invalidateQueries({ queryKey: foodOrderKeys.all });
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error, 'Не удалось создать тестовый заказ'));
    },
  });
}
